import React, { useEffect, useRef, useState } from "react";
import HeaderWithBack from "../../components/Header/headerWithBack";
import { Animated, View } from "react-native";
import { Text } from "react-native-svg";
import CustomPressable from "../../components/customPressable/customPressable";
import { useDispatch, useSelector } from "react-redux";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native-gesture-handler";
import { DEMO_FLOW_ENABLED } from "../../config/Constant";
import { setGoHome } from "../../Redux/Reducers/appConfigReducer";
import InfoPopupModal from "../../components/infoPopupModal";
import { DOOR_UNLOCK } from "../../assets";
import { ImageComp } from "../../components/Image/Image";
import triggerHapticFeedback from "../../js/vibration";
import { redirectToDeepLink } from "../../js/deeplink";


const ChamberKey = () => {

    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const { doorKeyType, loggedInRoomNumber } = useSelector(state => state.appConfigSlice);


    const ripples = useRef(
        Array.from({ length: 5 }, (_, i) => {
            return {
                scale: new Animated.Value(0),
                opacity: new Animated.Value(1),
            };
        })
    ).current;
    const animationLoopsRef = useRef([]);

    const [scanForLock, setScanForLock] = useState(false);


    const handleGoHome = () => {
        dispatch(setGoHome(true));
    }


    const openLock = () => {
        setScanForLock(true);
        triggerHapticFeedback("effectHeavyClick");
    }

    const deactivateFile = () => {
        setScanForLock(false);
    }

    const resetRipples = () => {
        ripples.forEach((ripple, i) => {
            const progress = i / ripples.length;
            ripple.scale.setValue(progress * 3);
            ripple.opacity.setValue(1 - progress);
        });
    }


    useEffect(() => {

        if (scanForLock) {
            setTimeout(() => {
                deactivateFile();
            }, 15000);


            resetRipples(); // add this line or face bug while starting animation again. Don't ask me why it works.

            ripples.forEach((ripple, index) => {

                let fromValue = 0;
                try {
                    fromValue = ripple.scale.__getValue?.() ?? 0;
                } catch (e) {
                    fromValue = 0;
                }
                const remainingDistance = 3 - fromValue;
                const duration = (remainingDistance / 0.5) * 1000;

                // 3. Play first animation from current scale to 3
                const animateToEnd = Animated.parallel([
                    Animated.timing(ripple.scale, {
                        toValue: 3,
                        duration: duration,
                        useNativeDriver: true,
                    }),
                    Animated.timing(ripple.opacity, {
                        toValue: 0,
                        duration: duration,
                        useNativeDriver: true,
                    }),
                ]);

                // 4. Once reached end, loop the full animation from 0
                const loop = Animated.loop(
                    Animated.sequence([
                        Animated.parallel([
                            Animated.timing(ripple.scale, {
                                toValue: 0,
                                duration: 0,
                                useNativeDriver: true,
                            }),
                            Animated.timing(ripple.opacity, {
                                toValue: 1,
                                duration: 0,
                                useNativeDriver: true,
                            }),
                        ]),
                        Animated.parallel([
                            Animated.timing(ripple.scale, {
                                toValue: 3,
                                duration: 6000,
                                useNativeDriver: true,
                            }),
                            Animated.timing(ripple.opacity, {
                                toValue: 0,
                                duration: 6000,
                                useNativeDriver: true,
                            }),
                        ]),
                    ])
                );

                // 5. Start the initial animate-to-end first, then loop
                animateToEnd.start(() => {
                    loop.start();
                });
                animationLoopsRef.current.push(loop);
            });
        } else {
            // stop animation
            animationLoopsRef.current.forEach(anim => anim.stop());
            animationLoopsRef.current = [];
            resetRipples();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scanForLock])


    useEffect(() => {
        resetRipples();

        return () => {
            deactivateFile();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <View style={getStyles(['widgetRootContainer', 'chamberRootContainer'])}>
            <HeaderWithBack />

            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainer', 'chamberMainContainer'])}>
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'chamberHeaderContainer'])}>
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'chamberHeaderTitleContainer'])}>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'chamberHeaderTitle'])}>{t('doorkey.chamber_key_unlock')}</Text>
                        <View style={getStyles(['chamberContainerHeaderSubTitleContainer'])}>
                            <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'chamberHeaderSubTitle'])}>{t('doorkey.room_number_label')}</Text>
                            <Text style={getStyles(['chamberHeadertertiaryTitle'])}>{loggedInRoomNumber}</Text>
                        </View>
                    </View>
                </View>


                <View style={getStyles(['widgetmainContainerChildContainer', 'chamberMainContainerChildContainer'])}>

                    <View style={getStyles(['chamberKey_ringsAnimationWrapper'])}>
                        {ripples.map((r, index) => (
                            <Animated.View
                                key={index}
                                style={
                                    getStyles(['chamberKey_innerrings',
                                        {
                                            position: 'absolute',
                                            width: 100,
                                            height: 100,
                                            borderRadius: 100,
                                            transform: [{ scale: r.scale }],
                                            opacity: r.opacity,
                                        }
                                    ])}
                            />
                        ))}
                        <CustomPressable disabled={scanForLock} onPress={() => openLock()}>
                            <Text style={getStyles(['chamberKey_innerrings_text'])}>
                                {scanForLock
                                    ? t('doorkey.scanning_for_key')
                                    : t('doorkey.press_to_open_button')}
                            </Text>
                        </CustomPressable>
                    </View>

                    <View style={getStyles(['chamberKey_guidecontianer'])}>
                        <ImageComp source={DOOR_UNLOCK} style={getStyles(['chamberKey_guidecontianer_img'])} />

                        <Text style={getStyles(['chamberKey_guidecontianer_guidetext'])}>
                            {t('doorkey.guide_text')}
                        </Text>
                    </View>
                </View>
            </ScrollView>

            {!DEMO_FLOW_ENABLED &&
                <InfoPopupModal
                    title={t('featureNotAvailable_web.heading')}
                    subtitle={t('featureNotAvailable_web.sub_heading')}
                    onContinue={() => {redirectToDeepLink(); handleGoHome();}}
                    primaryBtnLabel={t('featureNotAvailable_web.primary_button')}
                    onClose={handleGoHome}
                    secondaryBtnLabel={t('featureNotAvailable_web.secondary_button')}
                />
            }
        </View>
    );
}

export default ChamberKey;